import { useTranslation } from "react-i18next";
import React from "react";
import "./style.scss";
import { Flex } from "antd";
import {
  CheckOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useAddLesson } from "../../../../../stores/stores";

function QuizInfo() {
  const { t } = useTranslation();
  const question = useAddLesson((state: any) => state.question);
  const quizInfo = useAddLesson((state: any) => state.quizInfo);
  const bankName = quizInfo?.questionBank?.name;
  const isBankQuestion = location.pathname.includes("bank-question");

  return (
    <div className="quiz-info">
      <Flex align="center" gap={8} className="mb-1 font-weight-5">
        <InfoCircleOutlined />
        {t("Thông tin câu hỏi", "Thông tin câu hỏi")}
      </Flex>
      {question.type > 0 && (
        <div>
          <Flex gap={8}>
            <span>{t("Ngân hàng:", "Ngân hàng:")} </span> {bankName}
          </Flex>
          <Flex gap={8} align="center" className="mt-1">
            <span>{t("Phiên bản:", "Phiên bản:")} </span>{" "}
            {quizInfo?.questionBankVersion
              ? quizInfo?.questionBankVersion
              : "-"}
          </Flex>
          {isBankQuestion ? null : quizInfo?.isPublished ? (
            <div className="mt-1 text-green">
              <CheckOutlined className="text-green" /> {t("Đã được xuất bản", "Đã được xuất bản")}
            </div>
          ) : (
            <div className="mt-1">
              <WarningOutlined className="text-danger" /> {t("Chưa được xuất bản", "Chưa được xuất bản")}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default QuizInfo;
